import { List } from 'immutable'
import { AsyncState, loadedAsyncState, loadingAsyncState } from 'widgets-for-react'
import { Updater } from 'widgets-for-react'
import { headerApi } from './headerApi'

export type HeaderState = {
  menuOpened: boolean
  headerItemsState: AsyncState<List<HeaderItem>>
}

export type HeaderItem = {
  opened: boolean
  title: string
  children: {
    title: string
    url: string
  }[]
}

export const initialHeaderState: HeaderState = {
  menuOpened: false,
  headerItemsState: loadingAsyncState(headerApi),
}

export const headerStateUpdaters = {
  updateHeaderDataState:
    (updater: Updater<AsyncState<List<HeaderItem>>>) =>
    (currentState: HeaderState): HeaderState => ({
      ...currentState,
      headerItemsState: updater(currentState.headerItemsState),
    }),
  updateMenuOpened: (currentState: HeaderState): HeaderState => ({
    ...currentState,
    menuOpened: !currentState.menuOpened,
  }),
  updateItemOpened:
    (index: number) =>
    (currentState: HeaderState): HeaderState => {
      if (currentState.headerItemsState.kind === 'loaded') {
        const item = currentState.headerItemsState.value.get(index)
        if (item == undefined) return currentState
        else
          return {
            ...currentState,
            headerItemsState: loadedAsyncState<List<HeaderItem>>(
              currentState.headerItemsState.value.map((item, i) => ({
                ...item,
                opened: i === index ? !item.opened : false,
              }))
            ),
          }
      } else return currentState
    },
}
